import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { ThemeProvider } from "styled-components";

import { theme } from "../../style/theme";
import Footer from "../Footer";
import GlobalStyle from "../../style/GlobalStyles";
import { Wrapper } from "../../style/Grid";

const Layout = ({ children, variant }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <Helmet>
      <meta name="format-detection" content="telephone=no" />
    </Helmet>

    <Wrapper pt={["74px", null, "105px", "158px"]} variant={variant}>
      {children}
    </Wrapper>

    <Footer />
  </ThemeProvider>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
